// apps/tenant/src/lib/adapt-schema.ts
// Adapter from active_schema column to OSSchema.
//
// Currently active_schema is either a true OSSchema (post Architect generation)
// or a build-state shape: { architectState, inferredStyle, chatHistory }.
// The build-state shape cannot be rendered. Return null in that case so the
// caller falls back to a placeholder.

import type { OSSchema } from "@sloe/schema";

export function adaptActiveSchema(raw: unknown): OSSchema | null {
  if (!raw || typeof raw !== "object") return null;
  const obj = raw as Record<string, unknown>;
  if (!Array.isArray(obj.screens)) return null;
  if (!obj.navigation || typeof obj.navigation !== "object") return null;
  if (!obj.metadata || typeof obj.metadata !== "object") return null;
  return raw as OSSchema;
}
